/**
 * Utility module to work with sets.
 *
 * @module set
 */

const create = () => new Set();

export { create };
//# sourceMappingURL=set.js.map
